import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'corp-range-bar',
  imports:[CommonModule],
  templateUrl: './corp-range-bar.component.html'
})
export class CorpRangeBarComponent {

  @Input() min = 0;
  @Input() max = 100;

  @Input() minThreshold = 30;
  @Input() maxThreshold = 70;

  @Input() value = 0;
  @Output() valueChange = new EventEmitter<number>();

  ticks = Array.from({ length: 21 });

  // 🎯 INPUT
  onInput(event: Event) {
    let val = Number((event.target as HTMLInputElement).value);

    // (option) snap intelligent
    val = this.snap(val);

    this.value = val;
    this.valueChange.emit(val);
  }

  // 🧲 SNAP OPTIONNEL
  snap(val: number): number {
    const snapDistance = 2;

    if (Math.abs(val - this.minThreshold) <= snapDistance) return this.minThreshold;
    if (Math.abs(val - this.maxThreshold) <= snapDistance) return this.maxThreshold;

    return val;
  }

  // 📊 ZONES
  get minZonePercent() {
    return ((this.minThreshold - this.min) / (this.max - this.min)) * 100;
  }

  get okZonePercent() {
    return ((this.maxThreshold - this.minThreshold) / (this.max - this.min)) * 100;
  }

  get maxZonePercent() {
    return 100 - this.minZonePercent - this.okZonePercent;
  }

  // 📍 POSITIONS
  get valuePercent() {
    // return ((this.value - this.min) / (this.max - this.min)) * 100;
    return ((this.clampedValue - this.min) / (this.max - this.min)) * 100;
  }

  get minThresholdPercent() {
    // console.log('min', ((this.minThreshold - this.min) / (this.max - this.min)) * 100);
    return ((this.minThreshold - this.min) / (this.max - this.min)) * 100;
  }

  get maxThresholdPercent() {
    // console.log('max', ((this.maxThreshold - this.min) / (this.max - this.min)) * 100);
    return ((this.maxThreshold - this.min) / (this.max - this.min)) * 100;
  }

  get clampedValue(): number {
  return Math.min(this.value, this.max);
}

  // 🎨 THUMB STYLE DYNAMIQUE
  get thumbColorClass() {
    if (this.value < this.minThreshold) return '#CC110E';
    if (this.value > this.maxThreshold) return '#CC110E';
    return '#7BD3D6';
  }

  get thumbGlowClass() {
    if (this.value < this.minThreshold) return '#CC110E';
    if (this.value > this.maxThreshold) return '#CC110E';
    return '#7BD3D6';
  }
  
}